import styles from './TenantsManagement.module.css';
import '../../resources/css/admin_style.css';
import React, { useState } from "react";
import { TenantStatusContainer } from './tab/TenantStatusContainer';
import { TenantOwnerTransferContainer } from './tab/TenantOwnerTransferContainer';

export const ModalEnum = {
    REGISTER: 'register_one_button',
    DETAIL: 'modify_and_delete_two_button'
}

function TenantsManagement() {
    const [tab, setTab] = useState(0);

    return (
        <div className={styles.layoutWrapper}>
            <h3 className={styles.pageTitle}>통합 테넌트 관리</h3>
            <div className={styles.contentBox}>
                <div className={styles.tabList} role="tablist" aria-label="통합 테넌트 관리 탭">
                    <button
                        type="button"
                        role="tab"
                        aria-selected={tab === 0}
                        className={`${styles.tabButton} ${tab === 0 ? styles.tabButtonActive : ''}`}
                        onClick={() => setTab(0)}
                    >
                        승인대기
                    </button>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={tab === 1}
                        className={`${styles.tabButton} ${tab === 1 ? styles.tabButtonActive : ''}`}
                        onClick={() => setTab(1)}
                    >
                        소유주변경
                    </button>
                </div>
                <div className={styles.panelContent}>
                    {tab === 0 ? <TenantStatusContainer /> : <TenantOwnerTransferContainer />}
                </div>
            </div>
        </div>
    )
}

export default TenantsManagement;
